import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Flex, Text, Image } from '@chakra-ui/react';
import sharingInvalid from '../Images/icon/share_no_exist.svg';
import logoImg from '../Images/icon/logo.svg';
import Footer from '../Components/General/Footer';
import Chemical_data from '../Components/Cert/chemical_data';
export default function ShareChemical() {
  const { certName, date } = useParams();
  const [existed, setExisted] = useState(false);
  useEffect(() => {
    setExisted(true);
  }, []);

  return (
    <Stack h="100%" w="100%" bgColor={'#FFFFFF'}>
      <Flex w="100%" h="64px" justify="space-between" align="center">
        <Flex w="-webkit-fit-content" m={5} px={5} alignItems="center">
          <Image src={logoImg} />
          <Text fontSize="xl" color="#0B4654" ml={15}>
            化學雲區塊鏈應用
          </Text>
        </Flex>
        {existed && (
          <Text mx="22.5px" fontSize="20px" lineHeight="150%">
            此證書自 {date.replaceAll('-', '/')} 經持有人啟用分享
          </Text>
        )}
      </Flex>
      {existed ? (
        <Chemical_data show={true} certName={certName} />
      ) : (
        <Flex
          w="100%"
          minH="calc(100vh - 64px - 58px)"
          my="24px"
          direction="column"
          align="center"
          justify="center"
        >
          <Flex>
            <Text fontSize="20px" lineHight="150%" textAlign="center">
              此連結已失效
              <br />
              如欲瀏覽證書內容請與證書持有者聯繫
            </Text>
          </Flex>
          <Flex>
            <Image w="600px" h="288.25px" src={sharingInvalid} />
          </Flex>
        </Flex>
      )}
      <Footer />
    </Stack>
  );
}
